import { notification } from 'antd';
export const showSuccessNotification = (message: string) => {
    notification.success({
        message: 'Success',
        description: message,
        placement: 'top',
        duration: 4,
        key: 'success-notification',
        showProgress: true
    });
};
export const showErrorNotification = (message: string) => {
    notification.error({
        message: 'Error',
        description: message,
        placement: 'top',
        duration: 4,
        key: 'error-notification',
        showProgress: true
    });
};
export const showInfoNotification = (message: string) => {
    notification.info({
        message: 'Info',
        description: message,
        placement: 'topRight',
        duration: 4,
        key: 'info-notification',
    });
};
export const showWarnNotification = (message: string) => {
    notification.warning({
        message: 'Warning',
        description: message,
        placement: 'top',
        duration: 4,
        key: 'warn-notification',
    });
};